import { render, staticRenderFns } from "./ModalGuideLink.vue?vue&type=template&id=d389afa4&scoped=true&"
import script from "./ModalGuideLink.vue?vue&type=script&lang=ts&"
export * from "./ModalGuideLink.vue?vue&type=script&lang=ts&"
import style0 from "./ModalGuideLink.vue?vue&type=style&index=0&id=d389afa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d389afa4",
  null
  
)

export default component.exports